import React from "react";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";

export const formGroupOnSamsatAcceptance = {
    stnk: {
        processSamsatSTNKId: {value: null},
        processSamsatId: {value: ""},
        kodeCabang: {value: ""},
        namaPenerima: {value: ""},
        noSTNK: {value: "", mandatory: true},
        tanggalPenerimaanSTNK: {value: ""},
        base64FotoSTNK: {value: "", mandatory: true},
    },
    taxSheets: {
        processSamsatPajakId: {value: null},
        processSamsatId: {value: ""},
        kodeCabang: {value: ""},
        namaPenerima: {value: ""},
        noPajak: {value: "", mandatory: true},
        pajakProgresifPrice: {value: 0, mandatory: true},
        tglPenerimaanLembarPajak: {value: ""},
        fjOtherCost: {value: ""},
        otherCost: {value: 0},
    },
    platNumber: {
        processSamsatPlatId: {value: null},
        processSamsatId: {value: ""},
        namaPenerima: {value: ""},
        nomorPlat: {value: "", mandatory: true},
        kodeCabang: {value: ""},
        tglPenerimaanPlat: {value: 0},
        base64BuktiFisikPlat: {value: "", mandatory: true},
    },
    bpkb: {
        processSamsatBPKBId: {value: null},
        processSamsatId: {value: ""},
        kodeCabang: {value: ""},
        namaPenerima: {value: ""},
        nomorBPKB: {value: "", mandatory: true},
        tglPenerimaanBPKB: {value: 0},
        base64BuktiBPKB: {value: "", mandatory: true},
    },
}

export const initialData = {
    search: {
        namaSTNK: null,
    },
    filter: {
        startDate: null,
        endDate: null,
        noFakturJual: null,
        noBuku: null,
        kodeVariant: null,
        kodeWarna: null,
        namaSTNK: null,
        namaPembeli: null,
        noKa: null,
        noSin: null,
        startTglPenerimaanSTNK: null,
        endTglPenerimaanSTNK: null,
        startTglPenerimaanBPKB: null,
        endTglPenerimaanBPKB: null,
        startTglPenerimaanPlat: null,
        endTglPenerimaanPlat: null,
        startTglPenerimaanPajak: null,
        endTglPenerimaanPajak: null,
        namaSamsat: null,
        namaBirojasa: null,
        statusSTNK: null,
        statusBPKB: null,
        statusPlat: null,
        statusPajak: null,
    }
}

export const attributesInput = {
    stnk: {
        firstGrid: [
            {
                name: "namaPenerima",
                label: "Nama Penerima",
                correctionAble: false,
            },
            {
                name: "noSTNK",
                label: "Nomor STNK",
                correctionAble: true,
            },
            {
                name: "tanggalPenerimaanSTNK",
                label: "Tanggal Penerimaan STNK",
                correctionAble: false,
            }
        ],
        secondGrid: [
            {
                name: "base64FotoSTNK",
                label: "Bukti Fisik",
                correctionAble: true,
            },
        ]
    },
    taxSheets: {
        firstGrid: [
            {
                name: "namaPenerima",
                label: "Nama Penerima",
                correctionAble: false,
            },
            {
                name: "noPajak",
                label: "Nomor Pajak",
                correctionAble: true,
            },
            {
                name: "pajakProgresifPrice",
                label: "Pajak Progresif (Rp)",
                correctionAble: true,
            },
            {
                name: "tglPenerimaanLembarPajak",
                label: "Tanggal Penerimaan Lembar Pajak",
                correctionAble: false,
            },
            {
                name: "fjOtherCost",
                label: "Biaya Lain-Lain Dibebankan Konsumen Tentative",
                correctionAble: false,
            },
            {
                name: "otherCost",
                label: "Biaya Lain-Lain Dibebankan Konsumen",
                correctionAble: true,
            }
        ],
        secondGrid: []
    },
    platNumber: {
        firstGrid: [
            {
                name: "namaPenerima",
                label: "Nama Penerima",
                correctionAble: false,
            },
            {
                name: "nomorPlat",
                label: "Nomor Plat Kendaraan",
                correctionAble: true,
            },
            {
                name: "tglPenerimaanPlat",
                label: "Tanggal Penerimaan Plat",
                correctionAble: false,
            }
        ],
        secondGrid: [
            {
                name: "base64BuktiFisikPlat",
                label: "Bukti Fisik",
                correctionAble: true,
            },
        ]
    },
    bpkb: {
        firstGrid: [
            {
                name: "namaPenerima",
                label: "Nama Penerima",
                correctionAble: false,
            },
            {
                name: "nomorBPKB",
                label: "Nomor BPKB",
                correctionAble: true,
            },
            {
                name: "tglPenerimaanBPKB",
                label: "Tanggal Penerimaan BPKB",
                correctionAble: false,
            }
        ],
        secondGrid: [
            {
                name: "base64BuktiBPKB",
                label: "Bukti Fisik",
                correctionAble: true,
            },
        ]
    },
}

export const tableColumns = {
    mainPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "tanggalFakturJual",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorFakturJual",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorBuku",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "kodeVarian",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaVarian",
            label: "Nama Varian",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "kodeWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaWarna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaSTNK",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaPembeli",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "tanggalPenerimaanSTNK",
            label: "Tanggal Penerimaan STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "tanggalPenerimaanLembarPajak",
            label: "Tanggal Penerimaan Lembar Pajak",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "tanggalPenerimaanPlatKendaraan",
            label: "Tanggal Penerimaan Plat Kendaraan",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "tanggalPenerimaanBPKB",
            label: "Tanggal Penerimaan BPKB",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaSamsat",
            label: "Nama SAMSAT",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaBirojasa",
            label: "Nama Birojasa",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "statusSTNK",
            label: "STNK",
            options: {
                customBodyRender: (val) => {
                    return (
                        <SimpleCheckBox disabled checked={val}/>
                    )
                },
                sort: false,
            },
        },
        {
            name: "statusPajak",
            label: "Lembar Pajak",
            options: {
                customBodyRender: (val) => {
                    return (
                        <SimpleCheckBox disabled checked={val}/>
                    )
                },
                sort: false,
            },
        },
        {
            name: "statusPlat",
            label: "Plat Kendaraan",
            options: {
                customBodyRender: (val) => {
                    return (
                        <SimpleCheckBox disabled checked={val}/>
                    )
                },
                sort: false,
            },
        },
        {
            name: "statusBPKB",
            label: "BPKB",
            options: {
                customBodyRender: (val) => {
                    return (
                        <SimpleCheckBox disabled checked={val}/>
                    )
                },
                sort: false,
            },
        },
    ]
}
